<template lang="pug">
	.campaigns-table(v-if="Object.keys(orders).length" :campaigns="_.size(campaigns)" :time_range="timeFilter" :active_status="activeStatus")
		StandardKPIDisplay(:metricsMetadata="metricsMetadata" :campaigns="campaignsWithEventsFiltered")
		.campaigns-table-scroller
			table
				thead
					tr
						th.th-id(@click="sortTable('id')")
							div
								span Id
								i.fa.fa-sort(v-if="!sorting.includes('id')")
								i.fa.fa-sort-desc(v-else-if="sorting.includes('desc')")
								i.fa.fa-sort-asc(v-else)
						th.th-id(@click="sortTable('active')")
							div
								span Status
								i.fa.fa-sort(v-if="!sorting.includes('active')")
								i.fa.fa-sort-desc(v-else-if="sorting.includes('desc')")
								i.fa.fa-sort-asc(v-else)
						th.th-name(@click="sortTable('name')")
							div
								span Name
								i.fa.fa-sort(v-if="!sorting.includes('name')")
								i.fa.fa-sort-desc(v-else-if="sorting.includes('desc')")
								i.fa.fa-sort-asc(v-else)
						th.th-name(@click="sortTable('order_name')")
							div
								span Order
								i.fa.fa-sort(v-if="!sorting.includes('order_name')")
								i.fa.fa-sort-desc(v-else-if="sorting.includes('desc')")
								i.fa.fa-sort-asc(v-else)
						th.th-timestamp(@click="sortTable('latest_event')")
							div
								span Last
								i.fa.fa-sort(v-if="!sorting.includes('latest_event')")
								i.fa.fa-sort-desc(v-else-if="sorting.includes('desc')")
								i.fa.fa-sort-asc(v-else)
						th.th-metric(v-for="metric in metricsMetadata" @click="sortTable(`metrics.${metric.codename}`)")
							div
								span {{metric.title}}
								i.fa.fa-sort(v-if="!sorting.includes(metric.codename)")
								i.fa.fa-sort-desc(v-else-if="sorting.includes('desc')")
								i.fa.fa-sort-asc(v-else)
						th
				tbody
					tr(v-for="campaign in campaignsWithEventsFiltered")
						td.td-id {{campaign.id}}
						td.td-id
							i.fa.fa-play(v-if="campaign.active")
							i.fa.fa-pause(v-else)
						td.td-name
							a(href="#" @click="showCampaign(Order.Campaigns[campaign.id])") {{campaign.name}}
						td.td-name
							span {{campaign.order_name}}
						td.td-timestamp
							span {{campaign.latest_event ? campaign.latest_event.add(timezoneOffset, 'minute').format('D MMM YYYY HH:mm') : 'N/A'}}
						//td.td-name
							span {{orders[campaign.order_id] ? orders[campaign.order_id].name : 'ERROR'}}
						td.td-metric(v-for="metric in metricsMetadata") {{(campaign.metrics[metric.codename] || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}
						td.td-options
							ActionsDropdown(:type="'campaign'" :index="campaign.id" :campaign="campaign")

</template>

<script>
import Screen 			from './../../mixins/screen';
import {Order} 			from "@/services/Order";
import ActionsDropdown from "@/components/CustomControls/ActionsDropdown";
import StandardKPIDisplay from "@/components/Pages/StandardKPIDisplay";

export default {
	name: 'CampaignsTable',
	components: {
		ActionsDropdown,
		StandardKPIDisplay
	},
	mixins: [Screen],
	screen: {
		updateOn: ["Campaigns Loaded", "Orders Loaded", "Events Fetched"],
		events: {

		}
	},
	props: ["campaigns", "timeFilter", "activeStatus"],
	watch: {
		timeFilter() {
			Server.sendToSocket({
				FetchEvents: {
					campaignsIds: Object.keys(this.campaigns),
					timeFilter: this.timeFilter
				}
			});
		},
		activeStatus() {
			this.filterCampaigns();
		},
		campaigns() {
			this.filterCampaigns();
		}
	},
	data() {

		this.Order = Order;
		this.TrackingEvent = TrackingEvent;

		this.timezoneOffset = new Date().getTimezoneOffset();

		this.orders = [];
		this.campaignsWithEvents = [];
		this.campaignsWithEventsFiltered = [];

		return {
			metricsMetadata: {
				'impression': {
					codename: 'impression',
					title: 'Impressions',
					background: 'linear-gradient(-140deg, rgba(1,94,234,1) 0%, rgba(6,164,212,1) 100%)'
				},
				'click': {
					codename: 'click',
					title: 'Clicks',
					background: 'linear-gradient(-128deg, rgba(67,234,128,1) 0%, rgba(22,245,203,1) 100%)'
				},
				'did_engage': {
					codename: 'did_engage',
					title: 'Did Engage',
					background: 'linear-gradient(-139deg, rgba(247,176,20,1) 0%, rgba(246,202,107,1) 100%)'
				},
				'game_complete': {
					codename: 'game_complete',
					title: 'Game Complete',
					background: 'linear-gradient(53deg, rgba(245,109,95,1) 0%, rgba(182,50,62,1) 100%)'
				},
				'video_complete': {
					codename: 'video_complete',
					title: 'Video Complete',
					background: 'linear-gradient(53deg, rgba(249,168,89,1) 0%, rgba(243,122,4,1) 100%)'
				},
				'end_card_viewed': {
					codename: 'end_card_viewed',
					title: 'End Card Viewed',
					background: 'linear-gradient(53deg, rgba(213,142,240,1) 0%, rgba(145,60,190,1) 100%)'
				},

			},
			sorting: 'id|asc',
			showed: true
		}
	},
	methods: {
		collectData(action, ...params) {
			this.orders = Order.Orders;
			this.campaignsWithEvents = TrackingEvent.getCampaignsWithEvents();

			this.sortTable(this.sorting.split('|')[0], false);

			if (!this.campaignsWithEvents || !TrackingEvent.lastUpdate && Object.keys(this.campaigns).length) {
				Server.sendToSocket({
					FetchEvents: {
						campaignsIds: Object.keys(this.campaigns),
						timeFilter: this.timeFilter
					}
				});
			}

		},

		sortTable(property, reverse = true) {

			const currentSort = this.sorting.split('|');

			let newDir = currentSort[1];
			if (currentSort[0] === property && reverse) {
				if (currentSort[1] === 'asc') newDir = 'desc';
				else newDir = 'asc';
			}

			this.sorting = property + '|' + newDir;

			this.campaignsWithEvents.sort((a, b) => {
				if (newDir === 'asc') {
					return _.get(a, property, 0) >= _.get(b, property, 0) ? 1 : -1;
				} else {
					return _.get(a, property, 0) >= _.get(b, property, 0) ? -1 : 1;
				}

			});

			this.filterCampaigns();

			this.$forceUpdate();

		},
		filterCampaigns() {
			this.campaignsWithEventsFiltered = this.campaignsWithEvents.filter(campaign => this.filterStatus(campaign.active) && this.filterId(campaign.id));
		},
		filterStatus(value) {
			if (this.activeStatus === 'all') return true;
			if (this.activeStatus === 'active') return Boolean(value) === true;
			if (this.activeStatus === 'inactive') return Boolean(value) === false;
		},
		filterId(value) {
			return _.some(this.campaigns, campaign => campaign.id === value);
		},
		showCampaign(campaign) {
			Broadcast.call("Show ShowCampaign", [campaign]);
		}
	}
}

</script>

<style lang="sass">

	.campaigns-table
		display: flex
		flex-direction: column
		overflow: hidden
		gap: 40px

	.campaigns-table-scroller
		width: 100%
		overflow: hidden auto

		&::-webkit-scrollbar
			appearance: none
			width: 5px
		&::-webkit-scrollbar-thumb
			background-color: #343434
			border-radius: 15px

	table
		border: 0
		width: 100%
		padding: 0
		border-spacing: 0
		border-collapse: separate
		margin: 0
		font-size: 13px
		border-radius: 15px
		overflow: hidden

		>thead

			>tr
				background-color: #25252f

			th > div
				display: inline-flex
				cursor: pointer
				user-select: none
				align-items: center

			th > div > i
				padding-left: 5px

			th.th-name
				width: 250px
				padding-left: 10px

			th.th-timestamp
				width: 150px
				text-align: center

			th.th-id
				text-align: center

			th.th-metric
				width: 100px
				padding: 5px
				text-align: center

				>span
					display: inline-block
					text-align: center
		>tbody
			background-color: #2d2f3b

			tr
				white-space: nowrap

				.td-id
					width: 70px
					text-align: center

				.td-name
					padding-left: 10px

					>a
						color: #aaa1f5

						&:hover
							color: #66609d

				.td-timestamp
					text-align: center

				.td-metric
					text-align: center

				.td-options


		tr
			border-bottom: 1px solid #39383d
			border-radius: 10px

</style>
